import { motion, AnimatePresence } from 'framer-motion';
import { sections } from '../data/portfolioData';

interface NavigationArrowsProps {
  selectedIndex: number | null;
  onSelect: (index: number) => void;
}

export default function NavigationArrows({ selectedIndex, onSelect }: NavigationArrowsProps) {
  return (
    <AnimatePresence>
      {selectedIndex === null && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          className="fixed bottom-8 left-1/2 -translate-x-1/2 z-50
                     flex items-center gap-2 px-4 py-3 rounded-2xl
                     border border-white/10 backdrop-blur-xl"
          style={{
            background: 'linear-gradient(135deg, rgba(10,10,32,0.85), rgba(5,5,16,0.9))',
          }}
        >
          <span className="text-[11px] text-gray-500 font-mono uppercase tracking-wider mr-2 hidden sm:inline">
            Explore
          </span>
          {sections.map((section, i) => (
            <button
              key={section.id}
              onClick={() => onSelect(i)}
              className="group relative w-9 h-9 rounded-xl flex items-center justify-center
                         transition-all duration-300 hover:scale-110"
              style={{
                background: `${section.color}10`,
                border: `1px solid ${section.color}25`,
              }}
              onMouseEnter={(e) => {
                (e.currentTarget as HTMLElement).style.background = `${section.color}25`;
                (e.currentTarget as HTMLElement).style.borderColor = `${section.color}50`;
                (e.currentTarget as HTMLElement).style.boxShadow = `0 0 15px ${section.color}25`;
              }}
              onMouseLeave={(e) => {
                (e.currentTarget as HTMLElement).style.background = `${section.color}10`;
                (e.currentTarget as HTMLElement).style.borderColor = `${section.color}25`;
                (e.currentTarget as HTMLElement).style.boxShadow = 'none';
              }}
            >
              <span className="text-sm">{section.icon}</span>
              <div
                className="absolute -top-8 left-1/2 -translate-x-1/2
                           px-2 py-1 rounded-md text-[10px] whitespace-nowrap
                           opacity-0 group-hover:opacity-100 transition-opacity
                           pointer-events-none font-mono"
                style={{
                  background: 'rgba(5,5,16,0.95)',
                  border: `1px solid ${section.color}30`,
                  color: section.color,
                }}
              >
                {section.title}
              </div>
            </button>
          ))}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
